import React from "react"
import avatar from "avatar/klaus.svg"

const Klaus = (props) => <img src={avatar} className="avatar" {...props} />

export default Klaus
